import { PencilSimpleLine } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ILog } from 'bom/types';
import { Button, IButtonProps } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Color } from 'theme/enums';

import { UpsertLog } from './UpsertLog';

interface IProps extends IButtonProps {
  log: ILog;
  buttonElement?: ReactElement;
}

export const EditLogButton = ({ log, buttonElement, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const onSubmitSuccess = async (log: ILog) => updateRows({ update: [log] });

  const handleOnClose = () => setIsOpen(false);

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelUpdateLog')}
        color={Color.PRIMARY}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
        {...rest}
      />
    );
  }, [buttonElement, rest, t]);

  return (
    <>
      {button}

      <UpsertLog
        isOpen={isOpen}
        onClose={handleOnClose}
        log={log}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
